import { render } from "./ApplicationsChart.vue?vue&type=template&id=65d2f716&scoped=true"
import script from "./ApplicationsChart.vue?vue&type=script&lang=js"
export * from "./ApplicationsChart.vue?vue&type=script&lang=js"

import "./ApplicationsChart.vue?vue&type=style&index=0&id=65d2f716&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d2f716"]])

export default __exports__